module.exports = __webpack_public_path__ + "static/media/RegNumber.c7bac750.jpg";